import moment from "moment";
import Multiselect from "multiselect-react-dropdown";
import { useContext, useEffect, useRef, useState } from "react";
import { Button, Dropdown, Form, OverlayTrigger, Table, Tooltip } from "react-bootstrap";
import Modal from 'react-bootstrap/Modal';
import { withTranslation } from "react-i18next";
import { BiDownload, BiPencil, BiSort, BiSortDown, BiSortUp, BiToggleLeft, BiToggleRight, BiUpload } from "react-icons/bi";
import { BsFileEarmarkSpreadsheet, BsTrash } from "react-icons/bs";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import EnabledOnlyFilter from "../../../components/EnabledOnlyFilter/EnabledOnlyFilter";
import Pagination from "../../../components/Pagination/Pagination";
import { DEFAULT_ITEMS_PER_PAGE } from "../../../core/constants/common";
import useHasPermission from "../../../core/hooks/useHasPermission";
import CompanyService from "../../../core/service/CompanyService";
import FormService from "../../../core/service/FormService";
import UtilsService from "../../../core/service/UtilsService";
import Utils from "../../../core/utilities/Utils";
import EnterpriseStructureModal from "../../SubscriberSupplierAdmin/CompanySettings/EnterpriseStructureModal";
import { LoaderContext } from "../../../App";
import './EnterpriseGroup.scss';
const EnterpriseGroup = ({ t, epNodes, onEPStructureRefresh }) => {
	const [show, setShow] = useState(false);
	const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
	const [groupToDelete, setGroupToDelete] = useState(null);

	const handleClose = () => {
		{
			setFormData({
				id: 0,
				groupName: '',
				branches: [],
				enabled: true
			})
			setShow(false)
		}
	};
	const handleShow = () => { setShow(true) };
	const [groups, setGroups] = useState([]);
	const [itemsTotalCount, setItemsTotalCount] = useState(0);
	const [itemsPerPage, setItemsPerPage] = useState(20);
	const [currentPage, setCurrentPage] = useState(1);
	const [viewFilter, setViewFilter] = useState('enabled'); // 'enabled' or 'all'

	const [allBranches, setAllBranches] = useState([])
	const [validated, setValidated] = useState(false);
	const [formData, setFormData] = useState({
		id: 0,
		groupName: '',
		branches: [],
		enabled: true
	});
	const { hasSettingsUpdatePermission } = useHasPermission();
	const { setLoaderDisplay } = useContext(LoaderContext);
	const groupImportFileRef = useRef(null);

	// Entity edit modal state
	const [entityModalDisplay, setEntityModalDisplay] = useState(false);
	const [entityId, setEntityId] = useState(0);
	const [entityParentId, setEntityParentId] = useState(0);
	const [selectedEntity, setSelectedEntity] = useState(null);
	const [countries, setCountries] = useState([]);

	// Sorting state - default to lastModifiedDate,desc
	const [sortColumn, setSortColumn] = useState('lastModifiedDate');
	const [sortDirection, setSortDirection] = useState('desc');

	useEffect(() => {
		getGroups(1, DEFAULT_ITEMS_PER_PAGE);
		getCountries();
	}, [viewFilter]);

	useEffect(() => {
		if (epNodes?.length === 0) return;

		const flatNodes = getFlattenedNodes(epNodes);
		setAllBranches(flatNodes)
	}, [epNodes]);

	const getCountries = () => {
		UtilsService.getCountryList()
			.then((response) => {
				setCountries([...response.data]);
			})
			.catch((error) => {
			});
	};

	const getGroups = (pageNumber, itemsPerPageVal, sortCol = null, sortDir = null) => {
		let pageNum = pageNumber;
		if (pageNum > 0) {
			pageNum = pageNum - 1;
		} else {
			setCurrentPage(1);
			pageNum = 0;
		}
		let perPage;
		if (itemsPerPageVal > 0) {
			perPage = itemsPerPageVal;
		} else {
			perPage = itemsPerPage;
		}
		const enabledParam = viewFilter === 'enabled' ? true : undefined;
		const finalSortColumn = sortCol !== null ? sortCol : sortColumn;
		const finalSortDirection = sortDir !== null ? sortDir : sortDirection;
		const sortParam = `${finalSortColumn},${finalSortDirection}`;
		FormService.listGroupsPaginated(pageNum, perPage, enabledParam, sortParam).then(res => {
			if (res.status !== 200) return;

			setGroups(res.data?.data?.content || res.data?.content || res.data || []);
			const totalCount = res.data?.data?.totalElements || res.data?.totalElements || parseFloat(res.headers?.["x-total-count"]) || 0;
			setItemsTotalCount(totalCount);
			if (pageNumber > 0) {
				setCurrentPage(pageNumber);
			}

		}).catch(err => { });
	};

	const getFlattenedNodes = (nodes) => {
		let data = [];

		nodes?.forEach(node => {
			data.push({ id: node.id, name: node.name });

			if (!node.children) return;

			const children = getFlattenedNodes(node.children);
			children?.forEach(c => {
				data.push({ id: c.id, name: c.name });
			});
		});

		return data;

	};

	const onSelectDeSelectBranch = (selectedItem) => {
		const branchesClone = [...formData.branches];
		const index = formData.branches.findIndex(b => b.id === selectedItem.id);
		if (index >= 0) {
			branchesClone.splice(index, 1);
		} else {
			branchesClone.push({ id: selectedItem.id, name: selectedItem.name });



		}
		setFormData({
			...formData,
			branches: branchesClone
		});

	};

	const onSaveGroup = () => {

		setShow(false)

		if (formData.branches.length === 0 || !formData.groupName) {
			setValidated(true);
			return;
		}
		const branchesToSave = [];
		formData.branches.forEach(b => {
			branchesToSave.push({ branchId: b.id });
		});
		const dataToSave = {
			...formData,
			branches: branchesToSave,
			enabled: formData.enabled !== undefined ? formData.enabled : true
		};
		let req;
		if (dataToSave.id > 0) {
			delete dataToSave.id;
			req = FormService.updateGroup(formData.id, dataToSave);
		} else {
			delete dataToSave.id;
			req = FormService.createGroup(dataToSave);
		}
		req?.then(res => {
			if (res.status !== 201) return;

			toast.success("Success", {
				position: toast.POSITION.TOP_RIGHT,
			});

			setFormData({
				id: 0,
				groupName: '',
				branches: [],
				enabled: true
			});

			getGroups(currentPage, itemsPerPage);

		}).catch(err => { });
	};

	const onEdit = (group) => {
		setShow(true)
		const branchesToEdit = [];
		group.branches?.forEach(b => {
			branchesToEdit.push({ id: b.id, name: b.name });
		});
		setFormData({
			id: group.id,
			groupName: group.groupName,
			branches: branchesToEdit,
			enabled: group.enabled !== undefined ? group.enabled : true
		});

	};

	const onDelete = (group) => {
		setGroupToDelete(group);
		setShowDeleteConfirm(true);
	};

	const handleDeleteConfirm = (confirmed) => {
		setShowDeleteConfirm(false);
		if (confirmed && groupToDelete) {
			FormService.deleteGroup(groupToDelete.id)
				.then(res => {
					// Check response body status first (backend returns {status: "Failed", message: "..."})
					if (res.data?.status === 'Failed') {
						const errorMessage = res.data?.message || t("DeleteGroupError.label") || "Error deleting group";
						toast.error(errorMessage, {
							position: toast.POSITION.TOP_RIGHT,
						});
					} else if (res.status === 200 || res.status === 204 || res.status === 201) {
						toast.success(t("GroupDeletedSuccessfully.label") || "Group deleted successfully", {
							position: toast.POSITION.TOP_RIGHT,
						});
						getGroups(currentPage, itemsPerPage);
					} else {
						// Check if response has error message
						const errorMessage = res.data?.message || res.data?.detail || t("DeleteGroupError.label") || "Error deleting group";
						toast.error(errorMessage, {
							position: toast.POSITION.TOP_RIGHT,
						});
					}
				})
				.catch(err => {
					console.error('Delete group error:', err);
					// Extract error message from response
					const errorMessage = err.response?.data?.message ||
						err.response?.data?.detail ||
						(err.response?.data?.status === 'Failed' ? err.response?.data?.message : null) ||
						t("DeleteGroupError.label") ||
						"Error deleting group";
					toast.error(errorMessage, {
						position: toast.POSITION.TOP_RIGHT,
					});
				});
		}
		setGroupToDelete(null);
	};

	const onToggleEnable = (group) => {
		const newEnabledStatus = !group.enabled;
		const updatePayload = {
			groupName: group.groupName,
			branches: group.branches?.map(b => ({ branchId: b.id })) || [],
			enabled: newEnabledStatus
		};

		FormService.updateGroup(group.id, updatePayload)
			.then(res => {
				if (res.status === 200 || res.status === 201) {
					toast.success(newEnabledStatus ? t("GroupEnabledSuccessfully.label") : t("GroupDisabledSuccessfully.label"), {
						position: toast.POSITION.TOP_RIGHT,
					});
					getGroups(currentPage, itemsPerPage);
				}
			})
			.catch(err => {
			});
	};

	const onEditEntity = (branch) => {
		// Find parent node from epNodes
		const findParentNode = (nodes, targetId) => {
			for (const node of nodes) {
				if (node.id === targetId) {
					return null; // Root level
				}
				if (node.children) {
					const found = node.children.find(child => child.id === targetId);
					if (found) {
						return node;
					}
					const parent = findParentNode(node.children, targetId);
					if (parent !== undefined) {
						return parent;
					}
				}
			}
			return undefined;
		};

		const parentNode = findParentNode(epNodes, branch.id);
		setEntityId(branch.id);
		setEntityParentId(parentNode?.id ?? 0);
		setEntityModalDisplay(true);
		setSelectedEntity({ ...branch, openedFor: 'EDIT' });
	};

	// Get all parent nodes for the modal (flattened list)
	const getAllParentNodes = () => {
		const allNodes = [];
		const flattenNodes = (nodes) => {
			nodes?.forEach(node => {
				allNodes.push({ id: node.id, name: node.name });
				if (node.children) {
					flattenNodes(node.children);
				}
			});
		};
		flattenNodes(epNodes);
		return allNodes;
	};

	// Refresh enterprise structure after entity update
	const refreshEnterpriseStructure = () => {
		CompanyService.getEnterpriseStructure()
			.then(res => {
				if (res.status === 200 && onEPStructureRefresh) {
					onEPStructureRefresh(res.data.data);
				}
				// Also refresh groups to get updated entity data
				getGroups(currentPage, itemsPerPage);
			})
			.catch(err => {
			});
	};

	// Handle column sorting
	const handleSort = (columnKey) => {
		let newSortColumn = sortColumn;
		let newSortDirection = sortDirection;

		if (sortColumn === columnKey) {
			newSortDirection = sortDirection === 'asc' ? 'desc' : 'asc';
		} else {
			newSortColumn = columnKey;
			newSortDirection = 'asc';
		}
		setSortColumn(newSortColumn);
		setSortDirection(newSortDirection);
		setCurrentPage(1);
		getGroups(1, itemsPerPage, newSortColumn, newSortDirection);
	};

	// Get sort icon for column
	const getSortIcon = (columnKey) => {
		if (sortColumn !== columnKey) {
			return <BiSort className="ms-1" style={{ opacity: 0.3, cursor: 'pointer' }} />;
		}
		return sortDirection === 'asc'
			? <BiSortUp className="ms-1" style={{ cursor: 'pointer' }} />
			: <BiSortDown className="ms-1" style={{ cursor: 'pointer' }} />;
	};

	// Transform groups data for table display
	const getTableRows = () => {
		const rows = [];
		groups.forEach((group) => {
			if (!group.branches || group.branches.length === 0) {
				// If group has no branches, add one row with group name only
				rows.push({
					groupName: group.groupName,
					entityName: '-',
					dataOwners: '-',
					approver1stLevel: '-',
					approver2ndLevel: '-',
					approver3rdLevel: '-',
					dataValidators: '-',
					enabled: group.enabled !== undefined ? group.enabled : true,
					lastModifiedDate: group.lastModifiedDate || null,
					rowSpan: 1,
					isFirstRow: true,
					group: group
				});
			} else {
				group.branches?.sort((a, b) => a.name.localeCompare(b.name))?.forEach((branch, branchIndex) => {
					// Get data owners (emails) - as array
					const dataOwners = branch.emails && branch.emails.length > 0
						? branch.emails
						: 'NA';

					// Get reviewers by level
					const reviewers = branch.reviewers || [];
					const approver1st = reviewers.filter(r => r.level === 1);
					const approver2nd = reviewers.filter(r => r.level === 2);
					const approver3rd = reviewers.filter(r => r.level === 3);

					const approver1stLevel = approver1st.length > 0
						? approver1st.map(r => r.userEmail || r.userName)
						: 'NA';
					const approver2ndLevel = approver2nd.length > 0
						? approver2nd.map(r => r.userEmail || r.userName)
						: 'NA';
					const approver3rdLevel = approver3rd.length > 0
						? approver3rd.map(r => r.userEmail || r.userName)
						: 'NA';

					// Get data validators - as array (from dataValidatorList)
					const dataValidatorList = branch.dataValidatorList || branch.dataValidators || [];
					const dataValidators = dataValidatorList.length > 0
						? dataValidatorList.map(v => v.name || v.userEmail || v.userName || v.email).filter(Boolean)
						: 'NA';

					rows.push({
						groupName: group.groupName,
						entityName: branch.name,
						dataOwners: dataOwners,
						approver1stLevel: approver1stLevel,
						approver2ndLevel: approver2ndLevel,
						approver3rdLevel: approver3rdLevel,
						dataValidators: dataValidators,
						enabled: group.enabled !== undefined ? group.enabled : true,
						lastModifiedDate: group.lastModifiedDate || null,
						rowSpan: branchIndex === 0 ? group.branches.length : 0,
						isFirstRow: branchIndex === 0,
						group: group,
						branch: branch
					});
				});
			}
		});

		return rows;
	};

	// Server-side Excel export
	const handleServerSideExport = () => {
		// Prepare filter parameters (excluding pagination)
		const enabledParam = viewFilter === 'enabled' ? true : undefined;
		const sortParam = `${sortColumn},${sortDirection}`;
		
		FormService.exportGroupsExcel(enabledParam, sortParam)
			.then((response) => {
				const blob = new Blob([response.data], { 
					type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
				});
				const fileURL = window.URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = fileURL;
				link.download = `Enterprise_Groups_${new Date().toISOString().split('T')[0]}.xlsx`;
				link.click();
				link.remove();
				window.URL.revokeObjectURL(fileURL);
				
				toast.success(t("ExportSuccess.label") || "Data exported successfully", {
					position: toast.POSITION.TOP_RIGHT,
				});
			})
			.catch((error) => {
				console.error('Error exporting groups:', error);
				toast.error(t("ExportError.label") || "Error exporting data", {
					position: toast.POSITION.TOP_RIGHT,
				});
			});
	};

	// Export table data to Excel
	const handleExportToExcel = () => {
		// Use server-side download if total count exceeds page size
		if (itemsTotalCount > itemsPerPage) {
			handleServerSideExport();
			return;
		}

		// Client-side export for smaller datasets
		const tableRows = getTableRows();

		if (tableRows.length === 0) {
			toast.warning(t("NoDataToExport.label") || "No data available to export", {
				position: toast.POSITION.TOP_RIGHT,
			});
			return;
		}

		// Define column headers
		const headers = [
			t('GroupName.label'),
			t('Status.label'),
			t('Entities.label'),
			t('DataOwners.label'),
			t('DataApprover1stLevel.label'),
			t('DataApprover2ndLevel.label'),
			t('DataApprover3rdLevel.label'),
			t('DataValidators.label'),
			t('LastModified.label')
		];

		// Prepare data rows - include group name for each row (not using rowSpan in Excel)
		const excelData = tableRows.map(row => [
			row.groupName || '',
			row.enabled ? t('Enabled.label') : t('Disabled.label'),
			row.entityName || '',
			Array.isArray(row.dataOwners) ? row.dataOwners.join(', ') : (row.dataOwners || ''),
			Array.isArray(row.approver1stLevel) ? row.approver1stLevel.join(', ') : (row.approver1stLevel || ''),
			Array.isArray(row.approver2ndLevel) ? row.approver2ndLevel.join(', ') : (row.approver2ndLevel || ''),
			Array.isArray(row.approver3rdLevel) ? row.approver3rdLevel.join(', ') : (row.approver3rdLevel || ''),
			Array.isArray(row.dataValidators) ? row.dataValidators.join(', ') : (row.dataValidators || ''),
			row.lastModifiedDate ? moment(row.lastModifiedDate).format("MMM DD, YYYY") : '-'
		]);

		// Create workbook and worksheet
		const workbook = XLSX.utils.book_new();
		const worksheet = XLSX.utils.aoa_to_sheet([headers, ...excelData]);

		// Set column widths for better readability
		const colWidths = [
			{ wch: 20 }, // Group Name
			{ wch: 12 }, // Status
			{ wch: 25 }, // Entities
			{ wch: 30 }, // Data Owners
			{ wch: 30 }, // Data Approver 1st Level
			{ wch: 30 }, // Data Approver 2nd Level
			{ wch: 30 }, // Data Approver 3rd Level
			{ wch: 30 }, // Data Validators
			{ wch: 18 }  // Last Modified
		];
		worksheet['!cols'] = colWidths;

		// Add header row with bold formatting
		headers.forEach((header, colIndex) => {
			const cellAddress = XLSX.utils.encode_cell({ r: 0, c: colIndex });
			worksheet[cellAddress] = {
				t: 's',
				v: header,
				s: {
					font: { bold: true }
				}
			};
		});

		// Append worksheet to workbook
		XLSX.utils.book_append_sheet(workbook, worksheet, "Enterprise Groups");

		// Generate filename with timestamp
		const fileName = `Enterprise_Groups_${new Date().toISOString().split('T')[0]}.xlsx`;

		// Download the file
		XLSX.writeFile(workbook, fileName);

		toast.success(t("ExportSuccess.label") || "Data exported successfully", {
			position: toast.POSITION.TOP_RIGHT,
		});
	};

	// Download the group import template from the backend
	const handleDownloadTemplate = () => {
		FormService.downloadGroupsTemplate()
			.then((response) => {
				const blob = new Blob([response.data], {
					type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
				});
				const fileURL = window.URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = fileURL;
				link.download = `Enterprise_Groups_Template.xlsx`;
				link.click();
				link.remove();
				window.URL.revokeObjectURL(fileURL);
			})
			.catch((error) => {
				console.error('Error downloading group template:', error);
				toast.error(t("DownloadTemplateError.label") || "Error downloading template", {
					position: toast.POSITION.TOP_RIGHT,
				});
			});
	};

	const handleImportGroupsClick = () => {
		groupImportFileRef.current?.click();
	};

	const handleImportGroupsFile = (e) => {
		const file = e.target.files?.[0];
		if (!file) return;

		const formData = new FormData();
		formData.append("file", file);

		setLoaderDisplay(true);
		FormService.importGroups(formData)
			.then((response) => {
				// Backend wraps the import result in an envelope ({ status, message, data: {...} }) —
				// probe the nested shape first, falling back to a flat body if it isn't wrapped.
				const data = response.data?.data || response.data;
				const errorList = Array.isArray(data?.errors) ? data.errors : [];
				const errorCount = data?.errorCount ?? errorList.length;
				const summary = data?.message || response.data?.message || t("ImportGroupsError.label") || "Error importing groups";

				if (response.data?.status === 'Failed' || errorCount > 0) {
					toast.warning(
						<div>
							<div>{summary}</div>
							{errorList.map((line, idx) => (
								<div key={idx} style={{ color: 'red' }}>{line}</div>
							))}
						</div>,
						{
							position: toast.POSITION.TOP_RIGHT,
							autoClose: false,
						}
					);
				} else {
					toast.success(summary, {
						position: toast.POSITION.TOP_RIGHT,
					});
				}

				getGroups(currentPage, itemsPerPage);
			})
			.catch((error) => {
				console.error('Error importing groups:', error);
				const errorMessage = error.response?.data?.message ||
					error.response?.data?.detail ||
					t("ImportGroupsError.label") ||
					"Error importing groups";
				toast.error(errorMessage, {
					position: toast.POSITION.TOP_RIGHT,
				});
			})
			.finally(() => {
				e.target.value = "";
				setLoaderDisplay(false);
			});
	};

	return (
		<div className="p-2 enterprise-group-container">
			<div className="List_header pb-0">
				<h5 className="MH m-0">{t("Groups.label")}</h5>
				<div className="d-flex gap-2 align-items-center">
					<EnabledOnlyFilter
						viewFilter={viewFilter}
						onViewFilterChange={setViewFilter}
						dropdownId="enterprise-group-view-filter-dropdown"
					/>
					<OverlayTrigger
						placement="top"
						overlay={Utils.renderTooltip(
							t("Download.label")
						)}>
						<Dropdown>
							<Dropdown.Toggle variant="outline-secondary" id="download-groups-dropdown">
								<BiDownload />
							</Dropdown.Toggle>

							<Dropdown.Menu>
								<OverlayTrigger
									placement="top"
									overlay={Utils.renderTooltip(
										t("DownloadTemplate.label")
									)}>
									<Dropdown.Item onClick={() => handleDownloadTemplate()}>
										<BsFileEarmarkSpreadsheet className="me-1" /> {t("DownloadTemplate.label")}
									</Dropdown.Item>
								</OverlayTrigger>
								<OverlayTrigger
									placement="top"
									overlay={Utils.renderTooltip(
										t("DownloadAsExcel.label")
									)}>
									<Dropdown.Item onClick={() => handleExportToExcel()}>
										<BiDownload className="me-1" /> {t("DownloadAsExcel.label")}
									</Dropdown.Item>
								</OverlayTrigger>
							</Dropdown.Menu>
						</Dropdown>
					</OverlayTrigger>
					{hasSettingsUpdatePermission() && (
						<OverlayTrigger
							placement="top"
							overlay={<Tooltip id="upload-groups-tooltip">{t("Import.label")}</Tooltip>}
						>
							<Button variant="outline-secondary" onClick={handleImportGroupsClick}>
								<BiUpload />
							</Button>
						</OverlayTrigger>
					)}
					<input
						ref={groupImportFileRef}
						type="file"
						className="d-none"
						accept=".xlsx,.xls"
						onChange={handleImportGroupsFile}
					/>
					<Button variant="primary" onClick={handleShow} hidden={!hasSettingsUpdatePermission()}>
						+ {t("New.label")}
					</Button>
				</div>
			</div>
			<Form noValidate validated={validated}>
				<div className="mt-2">
					<div className="table-holder table-responsive">
						<Table responsive="sm" bordered>
							<thead>
								<tr>
									<th className="group-name-th">
										<span
											className="d-inline-flex align-items-center cursor-pointer"
											onClick={() => handleSort('groupName')}
										>
											{t('GroupName.label')}
											{getSortIcon('groupName')}
										</span>
									</th>
									<th className="status-name-th">
										<span
											className="d-inline-flex align-items-center cursor-pointer"
											onClick={() => handleSort('enabled')}
										>
											{t('Status.label')}
											{getSortIcon('enabled')}
										</span>
									</th>
									<th className="entity-name-th">
										{t('Entities.label')}
									</th>
									<th>{t('DataOwners.label')}</th>
									<th>{t('DataApprover1stLevel.label')}</th>
									<th>{t('DataApprover2ndLevel.label')}</th>
									<th>{t('DataApprover3rdLevel.label')}</th>
									<th>{t('DataValidators.label')}</th>
									<th>
										<span
											className="d-inline-flex align-items-center cursor-pointer"
											onClick={() => handleSort('lastModifiedDate')}
										>
											{t('LastModified.label')}
											{getSortIcon('lastModifiedDate')}
										</span>
									</th>
								</tr>
							</thead>
							<tbody>
								{(() => {
									const tableRows = getTableRows();
									return tableRows.length > 0 ? (
										tableRows.map((row, rowIndex) => {
										return (
											<tr
												key={`row-${rowIndex}`}
												id={`row-${rowIndex}`}
												className={row.isFirstRow ? 'Border_top_row' : ''}
											>
													{row.isFirstRow && (
														<td className="group-name-cell" rowSpan={row.rowSpan} style={{ verticalAlign: 'top' }}>
															<div className="group-name-container ">
																<div className="group-name-text">
																	{row.groupName}
																</div>
																{hasSettingsUpdatePermission() && (
																	<div className="group-name-edit-icon">
																		<OverlayTrigger
																			placement="top"
																			overlay={<Tooltip id="edit-group-tooltip">{t("EditGroup.label")}</Tooltip>}
																		>
																			<span>
																				<BiPencil
																					className="cursor-pointer text-primary"
																					onClick={() => onEdit(row.group)}
																					style={{ fontSize: '1.1rem' }}
																				/>
																			</span>
																		</OverlayTrigger>
																		<OverlayTrigger
																			placement="top"
																			overlay={<Tooltip id="delete-group-tooltip">{t("DeleteGroup.label")}</Tooltip>}
																		>
																			<span>
																				<BsTrash 
																					className="cursor-pointer text-danger" 
																					onClick={() => onDelete(row.group)}
																					style={{ fontSize: '1.1rem' }}
																				/>
																			</span>
																		</OverlayTrigger>
																		<OverlayTrigger
																			placement="top"
																			overlay={<Tooltip id="toggle-enable-tooltip">
																				{row.enabled ? t("DisableGroup.label") : t("EnableGroup.label")}
																			</Tooltip>}
																		>
																			<span>
																				{row.enabled ? (
																					<BiToggleRight
																						className="cursor-pointer text-success"
																						onClick={() => onToggleEnable(row.group)}
																						style={{ fontSize: '1.5rem' }}
																					/>
																				) : (
																					<BiToggleLeft
																						className="cursor-pointer text-secondary"
																						onClick={() => onToggleEnable(row.group)}
																						style={{ fontSize: '1.5rem' }}
																					/>
																				)}
																			</span>
																		</OverlayTrigger>
																	</div>
																)}
															</div>
														</td>
													)}
													{row.isFirstRow && (
														<td rowSpan={row.rowSpan} style={{ verticalAlign: 'top' }} className="status-name-cell">
															<span className={`badge ${row.enabled ? 'bg-success' : 'bg-secondary'}`}>
																{row.enabled ? t('Enabled.label') : t('Disabled.label')}
															</span>
														</td>
													)}
													<td className="entity-name-cell">
														<div className="d-flex align-items-center gap-2">
															<span>{row.entityName}</span>
															{row.branch && row.entityName !== '-' && hasSettingsUpdatePermission() && (
																<OverlayTrigger
																	placement="top"
																	overlay={<Tooltip id="edit-entity-tooltip">{t("EditEntity.label")}</Tooltip>}
																>
																	<span>
																		<BiPencil
																			className="cursor-pointer text-primary"
																			onClick={() => onEditEntity(row.branch)}
																			style={{ fontSize: '1.1rem' }}
																		/>
																	</span>
																</OverlayTrigger>
															)}
														</div>
													</td>
													<td>
														{Array.isArray(row.dataOwners) ? (
															row.dataOwners.map((email, idx) => (
																<div key={idx}>{email}</div>
															))
														) : (
															row.dataOwners
														)}
													</td>
													<td>
														{Array.isArray(row.approver1stLevel) ? (
															row.approver1stLevel.map((approver, idx) => (
																<div key={idx}>{approver}</div>
															))
														) : (
															row.approver1stLevel
														)}
													</td>
													<td>
														{Array.isArray(row.approver2ndLevel) ? (
															row.approver2ndLevel.map((approver, idx) => (
																<div key={idx}>{approver}</div>
															))
														) : (
															row.approver2ndLevel
														)}
													</td>
													<td>
														{Array.isArray(row.approver3rdLevel) ? (
															row.approver3rdLevel.map((approver, idx) => (
																<div key={idx}>{approver}</div>
															))
														) : (
															row.approver3rdLevel
														)}
													</td>
													<td>
														{Array.isArray(row.dataValidators) ? (
															row.dataValidators.map((validator, idx) => (
																<div key={idx}>{validator}</div>
															))
														) : (
															row.dataValidators
														)}
													</td>
													{row.isFirstRow && (
														<td rowSpan={row.rowSpan} style={{ verticalAlign: 'top' }}>
															{row.lastModifiedDate ? moment(row.lastModifiedDate).format("MMM DD, YYYY") : '-'}
														</td>
													)}
												</tr>
											);
										})
									) : (
										<tr>
											<td colSpan="9" className="text-center">
												{t("NoDataAvailable.label")}
											</td>
										</tr>
									);
								})()}
							</tbody>
						</Table>
					</div>
					{/* {itemsTotalCount > itemsPerPage && ( */}
					<div className="p-2 List_footer_count">
						<Pagination
							itemsTotalCount={itemsTotalCount}
							itemsPerPage={itemsPerPage}
							currentPage={currentPage}
							setCurrentPage={setCurrentPage}
							alwaysShown={true}
							setItemsPerPage={setItemsPerPage}
							pageClicked={(pageNum, perPage) => {
								getGroups(pageNum, perPage);
							}}
						/>
					</div>
					{/* )} */}
				</div>
			</Form>

			<Modal show={show} centered onHide={handleClose}>
				<Modal.Header closeButton>
					{formData.id === 0 ?
						<Modal.Title as="h5">{t("CreateNewGroup.label")}</Modal.Title>
						: <Modal.Title as="h5">{t("EditGroup.label")}</Modal.Title>
					}
				</Modal.Header>
				<Modal.Body>
					<div className="mb-2">
						<label className="mb-1">
							{t("Name.label")} *
						</label>
						<input
							required
							type="text"
							className="form-control"
							value={formData.groupName}
							onChange={(e) => setFormData({ ...formData, groupName: e.target.value })} />
					</div>
					<div className="mb-2">
						<label className="mb-1">{t("Entities.label")} *</label>
						<Multiselect
							options={allBranches.concat(formData.branches)}
							selectedValues={formData.branches}
							onSelect={(selectedList, selectedItem) => {
								onSelectDeSelectBranch(selectedItem);
							}}
							onRemove={(selectedList, selectedItem) => {
								onSelectDeSelectBranch(selectedItem);
							}}
							displayValue="name"
						/>
					</div>
					<div className="mb-2">
						<Form.Check
							type="checkbox"
							id="enabled-checkbox"
							label={t("Enabled.label")}
							checked={formData.enabled !== undefined ? formData.enabled : true}
							onChange={(e) => setFormData({ ...formData, enabled: e.target.checked })}
						/>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<div className="mb-2 text-center">
						{
							formData.id === 0 &&
							<Button variant="primary" onClick={() => onSaveGroup()}>
								{t("Create.label")}
							</Button>
						}
						{
							formData.id > 0 &&
							<>
								<Button className="mx-2" variant="secondary" onClick={() => {
									setFormData({
										id: 0,
										groupName: '',
										branches: [],
										enabled: true
									})
									setShow(false)
								}
								}>
									{t("Cancel.label")}
								</Button>
								<Button variant="primary" onClick={() => onSaveGroup()}>
									{t("Update.label")}
								</Button>

							</>
						}
					</div>
				</Modal.Footer>
			</Modal>

			{entityModalDisplay && (
				<EnterpriseStructureModal
					showModal={entityModalDisplay}
					id={entityId}
					parentId={entityParentId}
					modalData={selectedEntity}
					countries={countries}
					parent={getAllParentNodes()}
					onSaveCallBack={() => {
						setEntityId(0);
						setEntityParentId(0);
						setSelectedEntity(null);
						setEntityModalDisplay(false);
						refreshEnterpriseStructure();
					}}
					onCloseCallback={() => {
						setEntityModalDisplay(false);
						setEntityId(0);
						setEntityParentId(0);
						setSelectedEntity(null);
					}}
				/>
			)}

			{showDeleteConfirm && (
				<ConfirmationModal
					modalShow={true}
					messageText={t("DeleteGroupConfirmation.label") || `Are you sure you want to delete the group "${groupToDelete?.groupName}"?`}
					title={t("DeleteGroup.label") || "Delete Group"}
					confirmBtn={t("Delete.label") || "Delete"}
					CancelBtn={t("Cancel.label") || "Cancel"}
					callbackModal={handleDeleteConfirm}
					id={groupToDelete?.id}
				/>
			)}
		</div>
	);
};

export default withTranslation()(EnterpriseGroup);
